import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './slices/counterSlice';
import tasksReducer from './slices/tasksSlice';
import gameStatsReducer from './slices/gameStatsSlice';

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        tasks: tasksReducer,
        gameStats: gameStatsReducer,
    },
});
